import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import {Col, FormGroup, Input, Row} from 'reactstrap';
import _ from 'lodash';
import FontAwesome from 'react-fontawesome';
import PropTypes from 'prop-types';
import {Validacao} from "../../../comum/components/Validacao";
import Select from "react-select";

@inject("store")
@observer
export class DetalhamentoEmpregadosSubstituidos extends Component {

    static propTypes = {

    };

    constructor(props) {
        super(props);
    }

    render() {
        const empregadosSubstituidosForm = [];
        const solicitacao = this.props.controller.solicitacao;
        const exibeEmpregadosSubstituidos = this.props.controller.exibeEmpregadosSubstituidos;

        for(let i=0;i<_.get(solicitacao, "empregadosSubstituidos.length", 0);i++) {
            if(i === 0 || !_.get(solicitacao, "solicitacaoExcecao")){
                const cpf = _.get(solicitacao, "empregadosSubstituidos["+i+"].cpf", "") ? " ("+solicitacao.empregadosSubstituidos[i].cpf+")" : "";
                const empregado = _.get(solicitacao, "empregadosSubstituidos["+i+"].matricula", "") ? solicitacao.empregadosSubstituidos[i].matricula + " - " + solicitacao.empregadosSubstituidos[i].nome + cpf : "";
                empregadosSubstituidosForm.push(<Row key={i}>
                    <Col xs={12} lg={8}>
                        <FormGroup>
                            {i === 0}
                            <div className="multiple-selects">
                                <Input type="text" value={empregado} readOnly />
                            </div>
                        </FormGroup>
                    </Col>
                </Row>)
            }
        }

        return (
            <div>
                {exibeEmpregadosSubstituidos &&
                    <div>
                        <h4>Empregado substituído</h4>
                        {empregadosSubstituidosForm.length > 0 &&
                            <div>
                                {empregadosSubstituidosForm}
                            </div>
                        }
                        {empregadosSubstituidosForm.length < 1 &&
                        <div>
                            <span>Nenhum empregado informado.</span>
                        </div>
                        }
                    </div>
                }

            </div>
        )
    }
}